import { appConfig } from '@/model/config'
import { baseSet } from './driver/base_set'
import { calibrationHandler } from './driver/calibration_set'
import { operate, OperateType } from './driver/operate'
import { powerSet } from './driver/power_set'
import { magnetSetKeyGroup } from './driver/magnet_key_group'
import { isShowTester } from '@/components/tester/tester.vue'
import firmware from '@/upgrade/firmware'

export function resetAppState() {
  powerSet.clear()
  calibrationHandler.resetCalibrationStatus()
  operate.fnCheck.value = false
  baseSet.state.rateValue = 0
  operate.changeActionType(OperateType.none)
  firmware.clear()
  appConfig.isShowLeft = false
  magnetSetKeyGroup.state.isShowSetKeyGroup = false
  isShowTester.value = false
}
